export const generateId = (): number => Date.now();
